<template>
    <div class="modal-content">
        <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Отмена транзакции</h5>
        <button type="button" class="close" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body">
            <textarea placeholder="Укажите причину отмены транзакции" rows="4" class="form-control mt-4" id="cancelationReason" v-model="cancelationReason"></textarea>
        </div>
        <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="$emit('close')">Закрыть</button>
        <button type="button" class="btn btn-primary" @click="apply">Подтвердить</button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CancelTransactionPopup',
  props: {
    cancelTransaction: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      cancelationReason: ''
    }
  },
  methods: {
    apply () {
      this.cancelTransaction(this.cancelationReason)
      this.$emit('close')
    }
  }
}
</script>
